import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const Spinner = props => {
  const animationClasses = classnames('ndx-Spinner-animate', {
    'ndx-Spinner-animate--success': props.success
  });
  return (
    <div className="ndx-Spinner">
      <div className={animationClasses} />
    </div>
  );
};
const propTypes = {
  success: PropTypes.bool
};

Spinner.propTypes = propTypes;

export default Spinner;
